import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"

export default function Settings() {
  return (
    <div className="p-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4 border-b bg-gradient-to-r from-blue-50 to-indigo-50">
          <CardTitle className="text-2xl font-bold">Settings</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          {/* Add settings content here */}
        </CardContent>
      </Card>
    </div>
  )
} 